import React from "react";
import Services from "../components/Services/services";

const ServicePage = () => {
  return <Services />;
};

export default ServicePage;
